var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fund-list",class:{'fund-list-mobile' : _vm.isMobile == 'mobile'}},_vm._l((_vm.newsList),function(item,index){return _c('div',{key:item.id},[_c('listCard',{attrs:{"position":index%2>0?'right':'left',"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }